
<mat-dialog-content class="mat-typography" style="max-width: 40vw;color: rgba(0, 0, 0, .87);">
<h2>Welcome to the Reprocessing centre</h2>

  <p>After correcting any issues that may have disrupted the matching process, this page can be used to reprocess a work order without manual intervention in the Back office system. Work orders can only be reprocessed if they are (1) in a Not Supported, Unknown or Unmatched status and (2) received in the last 4 months of the current date.</p>

  <h2> How to: </h2>
  <ol>
    <li>Select all desired work orders from the work orders available to reprocess using the checkbox on the left of the work order. </li>
    <li>Once all desired work orders have been selected, click the Reprocess button. Results will automatically display once completed.</li>
    <li>Once reprocessing is complete you must click the Refresh button to reload the data on the screen. </li>
  </ol>

  <h2> Please Note: </h2>
  <ul>
    <li>A work order can only be reprocessed a maximum of 3 times, once the limit is reached it will no longer appear on this table.
    </li>
    <li>Only 100 work orders can be reprocessed at 1 time.</li>
    <li> While reprocessing do not click on any other pages in CSI.
    </li>
  </ul>
  <p>If another page is loaded while reprocessing the results of any reprocessed work orders will not be displayed however reprocessing will continue.</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button style="background-color: #354a55;
    color: #fff;" mat-dialog-close>Close</button>
</mat-dialog-actions>
